import React from "react";
// import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/joy/Box";
import Chip from "@mui/joy/Chip";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";

export default function Filtre({ onFilterChange }) {
  const [selected, setSelected] = React.useState("Tous");
  const radioRefs = React.useRef({});

  const handleSelection = (name) => {
    setSelected(name);
    onFilterChange(name);

    // Centrer l'élément sélectionné
    if (radioRefs.current[name]) {
      radioRefs.current[name].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "auto", // Permet le défilement horizontal
        whiteSpace: "nowrap",
        pt: 8,
        pl: 3,
        pr: 3,
        pb: 2,
        position: "relative",
        backgroundColor: "white",
      }}>
      <RadioGroup
        name="filter-bets"
        aria-labelledby="filter-bets"
        orientation="horizontal"
        sx={{
          display: "flex",
          gap: 1.5,
          border: "none",
        }}>
        {["Tous", "Ouverts", "À venir", "Terminé", "2024-2025"].map((name) => {
          const checked = selected === name;
          return (
            <Chip
              // variant="outlined"
              color="secondary"
              sx={{
                // transition: "all 0.3s ease-in-out",
                backgroundColor: checked
                  ? "rgba(90, 20, 121, 0.9)"
                  : "transparent",
                color: checked ? "white" : "rgba(90, 20, 121, 0.9)",
                borderRadius: "20px",
                cursor: "pointer",
                border: checked ? "none" : "1px solid rgba(90, 20, 121, 0.9)",

                "&:focus, &:focus-visible": {
                  outline: "none",
                  boxShadow: "none",
                },
              }}
              ref={(el) => (radioRefs.current[name] = el)}>
              <Radio
                sx={{
                  fontSize: "1rem",
                  color: checked ? "white" : "rgba(90, 20, 121, 0.9)",
                  padding: "10px 15px",
                  // Supprime la bordure du `span.MuiRadio-action`
                  "& .MuiRadio-action": {
                    border: "none !important",
                    boxShadow: "none !important",
                  },
                }}
                disableIcon
                overlay
                label={name}
                value={name}
                checked={checked}
                onChange={(event) => {
                  if (event.target.checked) {
                    handleSelection(name);
                  }
                }}
              />
            </Chip>
          );
        })}
      </RadioGroup>
    </Box>
  );
}
